import { createSettingsParams } from '@wix/tpa-settings';

import {
  displaySettingsParams,
  DisplaySettingsParams,
} from './Settings/Tabs/Display/settingsParams';
import {
  layoutSettingsParams,
  LayoutSettingsParams,
} from './Settings/Tabs/Layout/settingsParams';
import {
  menusSettingsParams,
  MenusSettingsParams,
} from './Settings/Tabs/Menus/settingsParams';
import {
  textSettingsParams,
  TextSettingsParams,
} from './Settings/Tabs/Text/settingsParams';

export type SettingsParams = DisplaySettingsParams &
  LayoutSettingsParams &
  MenusSettingsParams &
  TextSettingsParams;

export default createSettingsParams<SettingsParams>({
  ...displaySettingsParams,
  ...layoutSettingsParams,
  ...menusSettingsParams,
  ...textSettingsParams,
});
